import React from 'react';


function TermsOfService() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Terms of Service</h1>

        <div className="space-y-8 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing the AI Accountability Standards Council (AASC) website, you agree to be bound by these Terms of Service. If you do not agree, please discontinue use of the site.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">2. Site Purpose</h2>
            <p>
              This website exists solely for the definition, publication, and dissemination of technical standards for organization using AI operations. This site does not process declaration applications, collect fees, or manage registry data. declaration and registry functions are handled exclusively by the separate Registry Platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">3. Intellectual Property</h2>
            <p>
              All content, standards definitions, text, and graphics on this site are the property of the AI Accountability Standards Council or its licensors. The "AASC" name and logo are trademarks of the Council. Unauthorized use is prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">4. Use Restrictions</h2>
            <p>
              You may not use this site for any illegal purpose. You may not attempt to compromise site security or interfere with its proper operation. You may not scrape or systematically extract data without permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">5. Disclaimers</h2>
            <p className="uppercase text-sm font-bold">
              The materials on this website are provided "as is". The Council makes no warranties, expressed or implied, regarding the accuracy, completeness, or reliability of the materials.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">6. Limitation of Liability</h2>
            <p className="uppercase text-sm font-bold">
              In no event shall the Council be liable for any damages arising out of the use or inability to use the materials on this website.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">7. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless the Council from any claims arising out of your use of the site or violation of these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">8. External Links</h2>
            <p>
              Links to third-party sites, including the Registry Platform, are provided for convenience. The Council does not control and is not responsible for the content or availability of external sites.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">9. Termination</h2>
            <p>
              The Council reserves the right to terminate access to the site at any time, for any reason, without notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">10. Governing Law</h2>
            <p>
              These terms are governed by the laws of the jurisdiction in which the Council is established, without regard to conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-3">11. Contact</h2>
            <p>
              Questions regarding these Terms should be directed to legal@aiaccountabilitycouncil.com.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default TermsOfService;